export default {
  login: {},
  header: {
    foreColor: '#fff',
    backgroundColor: '#1797be',
    height: 60,
    leftMenu: {
      foreColor: '#fff',
      backgroundColor: '#1797be',
      activeTextColor: '#1797be'
    },
    rightMenu: {
      foreColor: '#fff',
      backgroundColor: '#1797be',
      activeTextColor: '#1797be'
    }
  },
  aside: {
    foreColor: '#e1e2e3',
    backgroundColor: '#3a3f51',
    width: 200,
    menu:{
      foreColor: '#e1e2e3',
      backgroundColor: '#3a3f51',
      activeTextColor: '#1797be'
    }
  }
};
